import { Link } from 'react-router-dom';
import FeedbackForm from './components/FeedbackForm';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { aboutStats } from '@/mocks/home';

const services = [
  {
    icon: 'ri-movie-2-line',
    title: '影视内容整理',
    description: '系统整理了电视剧与电影的类型、地区、年份与题材信息，帮助你快速了解每部作品。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '多维分类筛选',
    description: '支持按类型、地区、年份、评分与标签组合筛选，让你在大量作品中精准找到想看的内容。',
  },
  {
    icon: 'ri-team-line',
    title: '演员资料查询',
    description: '聚合演员头像、代表作品与简介，从剧情到演员，为你提供完整的了解路径。',
  },
  {
    icon: 'ri-newspaper-line',
    title: '影视资讯追踪',
    description: '持续整理电影新闻、电视剧动态与行业观察，让你随时把握影视圈的最新风向。',
  },
];

export default function AboutPage() {
  useDocumentMeta({
    title: '关于我们 - 粉色水蜜桃综合影视站',
    description:
      '粉色水蜜桃是一个专注电视剧、电影内容展示与影视资讯的综合影视站，提供剧情介绍、演员资料、分类筛选与资讯浏览服务。',
    keywords: '粉色水蜜桃,关于我们,影视网站,影视资讯,剧情介绍,演员资料',
  });

  return (
    <div>
      <section className="border-b border-background-200 bg-primary-50">
        <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
          <nav className="flex items-center gap-2 text-sm text-foreground-500" aria-label="面包屑">
            <Link to="/" className="transition-colors hover:text-primary-600">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            关于粉色水蜜桃
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-700 md:text-base">
            粉色水蜜桃是一个综合影视内容展示与资讯平台，聚焦电视剧、电影资源与影视资讯。我们希望通过清晰的分类、详尽的剧情介绍与演员资料，帮助每一位影视爱好者更方便地浏览、了解并发现自己喜欢的作品。
          </p>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600">
            本站所有影视、演员与评分信息均为演示数据，不含真实播放、下载与会员功能，仅用于展示网站的内容组织与浏览体验。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          我们的服务
        </h2>
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service) => (
            <div
              key={service.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                <i className={`${service.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{service.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-12">
          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
            {aboutStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-50 p-5 text-center"
              >
                <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
                  {stat.value}
                </p>
                <p className="mt-1.5 text-sm text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
          <p className="mt-4 text-center text-xs text-foreground-500">
            以上数据为演示示例，不代表真实统计结果。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[320px_minmax(0,1fr)]">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              联系我们
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              如果你发现了内容错误、希望申请收录某部作品，或对网站功能有任何建议，欢迎通过下方方式与我们联系。
            </p>
            <div className="mt-6 space-y-4">
              <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className="ri-mail-line text-xl" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">联系邮箱</p>
                  <p className="text-sm font-medium text-foreground-900">hello@pinkpeach-demo.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                  <i className="ri-time-line text-xl" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">回复时间</p>
                  <p className="text-sm font-medium text-foreground-900">
                    工作日 09:00 - 18:00（演示）
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              意见反馈
            </h2>
            <p className="mt-3 text-sm text-foreground-600">
              填写下方表单即可提交你的反馈，我们会认真阅读每一条建议。
            </p>
            <div className="mt-5">
              <FeedbackForm />
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 pb-14 md:px-6 md:pb-16">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            版权及声明
          </h2>
          <ul className="mt-4 space-y-2.5 text-sm leading-relaxed text-foreground-600">
            <li>本站所有影视作品封面、资讯配图与演员头像均为 AI 生成的演示素材，仅供功能展示。</li>
            <li>站内的剧情简介、评分、演员资料与资讯内容均为虚构示例，不构成对任何真实作品的描述。</li>
            <li>本站不提供真实视频播放、下载及会员服务，如对内容来源有疑问，可通过上方邮箱联系我们。</li>
            <li>收藏与浏览记录仅保存在你的本机浏览器缓存中，未登录状态下不会上传至服务器。</li>
          </ul>
        </div>
      </section>
    </div>
  );
}